import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import { theme } from '../../services/theme';

interface Props {
  isLoading?: boolean;
  text?: string;
}

export const EmptyList = ({ isLoading, text }: Props) =>
  isLoading ? (
    <Box sx={{ textAlign: 'center', width: '100%', overflow: 'hidden' }}>
      <CircularProgress size={24} />
    </Box>
  ) : (
    <Typography
      fontWeight="regular"
      sx={{
        color: '#9AB1C0',
        fontSize: '16px',
        fontWeight: '600',
        lineHeight: '20px',
        marginBottom: '10px',
        [theme.breakpoints.down('sm')]: {
          fontSize: '14px',
          lineHeight: '16px',
        },
        [theme.breakpoints.down('mobile')]: {
          fontSize: '12px',
          lineHeight: '14px',
        },
      }}
    >
      {text || 'There are no items to display.'}
    </Typography>
  );
